import { cn } from "@/lib/utils";
import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  size?: "sm" | "md" | "lg";
  children: ReactNode;
}

/* Primary matches the landing CTA: flat yellow pill, ink text, soft
   shadow, gentle lift. No black borders or hard offset shadows. */
const variantStyles = {
  primary:
    "bg-home-yellow text-home-ink shadow-[0_10px_28px_-12px_rgba(33,31,28,0.4)] hover:-translate-y-0.5 hover:shadow-[0_16px_34px_-12px_rgba(33,31,28,0.45)] disabled:opacity-50 disabled:hover:translate-y-0",
  secondary:
    "bg-transparent text-black border border-black/15 hover:bg-black hover:text-white dark:text-white dark:border-white/20 dark:hover:bg-white dark:hover:text-black",
  ghost:
    "bg-transparent text-black/70 hover:underline dark:text-white/70 border-none",
};

const sizeStyles = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-3 text-base",
  lg: "px-8 py-4 text-lg",
};

export function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "rounded-full font-bold transition-all duration-300 ease-out",
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
